import { formatDate } from "@/lib/api";
import { growth } from "@/lib/growth";
import { CartesianGrid, Line, LineChart, Tooltip, XAxis, YAxis } from "recharts";

export const ScoreChart = ({ items }) => {
    const data = [...items].reverse().map((s) => ({ date: formatDate(s.submitted_at), score: s.score_total, level: s.level }));
    return (
        <figure className="mt-4" data-testid="score-chart">
            <div className="h-64 w-full text-edi-text" role="img" aria-label="Grafico dell'andamento del punteggio nel tempo. I dati sono riportati nella tabella seguente.">
                    <LineChart responsive style={{ width: "100%", height: "100%" }} data={data} margin={{ top: 10, right: 16, left: -16, bottom: 0 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#9aa2a5" />
                        <XAxis dataKey="date" tick={{ fill: "currentColor" }} className="text-edi-text" />
                        <YAxis domain={[0, 100]} tick={{ fill: "currentColor" }} />
                        <Tooltip />
                        <Line type="monotone" dataKey="score" name="Punteggio" stroke="currentColor" strokeWidth={2} dot={{ r: 5, fill: "#BCCF00", stroke: "currentColor", strokeWidth: 1.5 }} isAnimationActive={false} />
                    </LineChart>
            </div>
            <figcaption className="sr-only">Andamento del punteggio nel tempo</figcaption>
            <div className="overflow-x-auto mt-4">
                <table className="w-full text-left text-sm" data-testid="score-chart-table">
                    <caption className="text-left font-semibold mb-2">Andamento del punteggio nel tempo (dati del grafico)</caption>
                    <thead><tr className="border-b border-edi-border-strong"><th scope="col" className="py-2 pr-4">Data</th><th scope="col" className="py-2 pr-4">Punteggio</th><th scope="col" className="py-2 pr-4">Livello</th><th scope="col" className="py-2">Variazione sul precedente</th></tr></thead>
                    <tbody>
                        {data.map((d, i) => <tr key={i} className="border-b border-edi-border"><td className="py-2 pr-4">{d.date}</td><td className="py-2 pr-4">{d.score}</td><td className="py-2 pr-4">{d.level}</td><td className="py-2" data-testid={`trend-growth-${i}`}>{i === 0 ? "—" : (() => { const g = growth(d.score, data[i - 1].score); return g.dir ? `${g.text} (${{ up: "in crescita", down: "in calo", flat: "invariato" }[g.dir]})` : g.text; })()}</td></tr>)}
                    </tbody>
                </table>
            </div>
        </figure>
    );
};

